<template>
  <div class="simple" v-loading.fullscreen.lock="loading">
    <div class="simple_btn" @click="reservaVisible = true"></div>
    <el-dialog
      :visible.sync="sucVisible"
      width="78.94vw"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :modal="true"
      :modal-append-to-body="false">
      <div :class="['suc_dia', ispc ? '' : 'mobile_suc', repeatPhone ? 'repeat_phone' : '']">
        <div class="close" @click="sucVisible = false"></div>
        <div class="dia_btns" v-if="!repeatPhone">
          <div @click="toAppStore"></div>
          <div @click="toGoogle"></div>
        </div>
        <div v-else class="dia_fb" @click="toFB"></div>
      </div>
    </el-dialog>
    <el-dialog
      top="0"
      :visible.sync="reservaVisible"
      width="100vw"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :modal="true"
      :modal-append-to-body="false">
      <div class="reserva_dia">
        <div class="reserva_container">
          <img src="@/assets/xianni/reserva_pop_bg.png" class="reserva_pop_bg" alt="" />
          <div class="close" @click="reservaVisible = false"></div>
          <selectInput @confirm="phoneConfirm" :isCommon="false" :ispc="ispc"></selectInput>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reserveRegUserPhone, reserveUserNum } from '@/api/index'
import buryingPoint from '@/mixins/buryingPoint'
import selectInput from '../component/selectInput.vue'

export function debounce(func, wait) {
  let timeout
  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

export default {
  mixins: [buryingPoint],
  components: {
    selectInput
  },
  data() {
    return {
      sucVisible: false,
      reservaVisible: true,
      ispc: this.isPC(),
      loading: false,
      repeatPhone: false
    }
  },
  created() {
    if (this.ispc) {
      this.$router.push('/')
    }
  },
  methods: {
    async phoneConfirm(params) {
      this.loading = true
      try {
        const res = await reserveRegUserPhone({
          phone_type: params.selectValue.value,
          phone: params.inputvalue
          // app_type: this.isAppleDevice() ? 1 : 0
        })
        if (res.data.errorcode) {
          this.ispc ? this.$message.error(res.data.msg) : this.$toast(res.data.msg)
        } else {
          this.sucVisible = true
          this.reservaVisible = false
          this.repeatPhone = !res.data.status_new
          res.data.status_new && this.reservationSuccess()
        }
      } finally {
        this.loading = false
      }
    },

    isPC() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return false
      } else {
        return true
      }
    },
    toAppStore() {
      // window.open('https://apps.apple.com/tw/app/id1649252222')
    },
    toGoogle() {
      window.open('https://play.google.com/store/apps/details?id=com.xianni.tw')
    },
    toFB() {
      this.clickStore()
      window.open('https://www.facebook.com/xnmobiletw')
    }
  }
}
</script>

<style lang="less" scoped>
.simple {
  height: 100vh;
  width: 100vw;
  background: #132040 url('@/assets/xianni/simple_bg.png') no-repeat 0 0 / 100% auto;
  .simple_btn {
    width: 64.8vw;
    height: 21.46vw;
    left: 50%;
    transform: translate(-50%);
    bottom: 6vw;
    position: absolute;
    background: url('@/assets/xianni/simple_btn.png') no-repeat 0 0 / 100% auto;
  }
}
.suc_dia {
  width: 92.6vh;
  height: 60vh;
  position: relative;
  background: url('@/assets/xianni/pop_1.png') no-repeat 0 0 / 100% 100%;
  &.repeat_phone {
    background: url('@/assets/xianni/pop_0.png') no-repeat 0 0 / 100% 100%;
    width: 99.4vh;
  }
  .close {
    position: absolute;
    width: 10vh;
    height: 10vh;
    top: 0;
    right: 0;
  }
  .dia_btns {
    display: flex;
    position: absolute;
    bottom: 6.2vh;
    left: 27.8vh;
    gap: 1.8vh;
    > div {
      width: 16.8vh;
      height: 4.8vh;
    }
  }
  .dia_fb {
    position: absolute;
    bottom: 4vh;
    left: 27.2vh;
    width: 39.1vh;
    height: 10.25vh;
    background: url('@/assets/xianni/pop_f_zan.png') no-repeat 0 0 / 100% 100%;
  }
  &.mobile_suc {
    width: 78.94vw;
    height: 51.14vw;
    &.repeat_phone {
      height: 45.75vw;
    }
    .close {
      position: absolute;
      width: 8vw;
      height: 8vw;
      top: 0;
      right: 0;
    }
    .dia_btns {
      display: flex;
      position: absolute;
      bottom: 5.4vw;
      left: 23vw;
      gap: 1.6vw;
      > div {
        width: 14.8vw;
        height: 4.5vw;
      }
    }
    .dia_fb {
      bottom: 3.8vw;
      left: 23.6vw;
      width: 26.7vw;
      height: 7vw;
    }
  }
}

.reserva_dia {
  display: flex;
  justify-content: center;
  .reserva_container {
    position: relative;
    transform: scale(0.94);
  }
  .reserva_pop_bg {
    display: block;
    height: 100vh;
    width: auto;
  }
  .close {
    position: absolute;
    width: 4.6vh;
    height: 4.6vh;
    top: 0;
    right: 8vh;
  }
}

::v-deep .el-dialog {
  background: transparent;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
  background: transparent;
}
</style>
